const getTitle = (propertyTitle, pageName) =>
  propertyTitle ? `${pageName} | ${propertyTitle}` : pageName;

const getImage = (socialFallbackImage) => (socialFallbackImage ? socialFallbackImage.url : null);

const shouldNoIndex = () => {
  if (typeof window === 'undefined') {
    return false;
  }

  return ['release', 'development', 'staging'].some((s) => window.location.href.includes(s));
};

const SeoConfig = ({
  homepage,
  language: lang,
  locale,
  pageName,
  propertyTitle,
  socialFallbackImage,
  url,
}) => ({
  title: getTitle(propertyTitle, pageName),
  description: homepage ? homepage.heroSummary : null,
  lang,
  dangerouslySetAllPagesToNoIndex: shouldNoIndex(),
  openGraph: {
    description: homepage ? homepage.heroSummary : null,
    images: [{ url: getImage(socialFallbackImage) }],
    locale,
    title: getTitle(propertyTitle, pageName),
    url,
  },
});

export default SeoConfig;
